import React from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";


//pre login page
import RegistrationPage from "../pages/RegistrationPage";
import Resend from "../pages/Resend";
import AccountValidated from "../pages/AccountValidated";
import ConfirmationForm from "../pages/ConfirmationForm";
import LoginPage from "../pages/LoginPage";
import ForgetPassword from "../pages/ForgetPassword";
import ResetPassword from "../pages/ResetPassword";
import VerifyAccount from "../pages/VerifyAccount";

//Post login pages
import Organization from "../pages/Organization";
import OrganizationDetails from "../pages/OrganizationDetails";
import Monitor from "../pages/Monitor";
import MonitorDetails from "../pages/MonitorDetails";
import Users from "../pages/Users";
import UserDetails from "../pages/UserDetails";
import Domain from "../pages/Domain";
import DomainDetails from "../pages/DomainDetails";
import ScanHistory from "../pages/ScanHistory";
import ScanQueue from "../pages/ScanQueue";
import AccountSettings from "../pages/AccountSettings";
import Customers from "../pages/Customers";
import CustomerDetails from "../pages/CustomerDetails";

//scan info pages exposure management pages
import ScanInfo from "../pages/ScanInfo";

// exposure management dashboard
import ExposureDashboard from "../pages/ScanInfoPages/ExposureManagement/Dashboard";

// exposure managemnt assest discovery pages
import DomainInfo from "../pages/ScanInfoPages/ExposureManagement/AssetDiscovery/DomainInfo";
import SubDomains from "../pages/ScanInfoPages/ExposureManagement/AssetDiscovery/SubDomain";
import AssociatedDomains from "../pages/ScanInfoPages/ExposureManagement/AssetDiscovery/AssociatedDomain";
import IpAddress from "../pages/ScanInfoPages/ExposureManagement/AssetDiscovery/IpAddress";
import DNSRecords from "../pages/ScanInfoPages/ExposureManagement/AssetDiscovery/DNSRecords";
import Technologies from "../pages/ScanInfoPages/ExposureManagement/AssetDiscovery/Technologies";
import SSLRecords from "../pages/ScanInfoPages/ExposureManagement/AssetDiscovery/SSLRecords";
import MobileApps from "../pages/ScanInfoPages/ExposureManagement/AssetDiscovery/MobileApps";

//exposure management corporate email risk page
import CorporateEmailRisk from "../pages/ScanInfoPages/ExposureManagement/CorporateEmailRisk";


// exposure management concerning exposure pages
import GitLeaks from "../pages/ScanInfoPages/ExposureManagement/ConcerningExposure/GitLeaks";
import JsSecrets from "../pages/ScanInfoPages/ExposureManagement/ConcerningExposure/JsSecrets";
import SensitiveExposure from "../pages/ScanInfoPages/ExposureManagement/ConcerningExposure/SensitiveExposure";


// exposure management external detected vulnerabilities pages
import SubDomainTakeOver from "../pages/ScanInfoPages/ExposureManagement/ExternalDetectedVulnerabilities/SubDomainTakeover";
import CVEs from "../pages/ScanInfoPages/ExposureManagement/ExternalDetectedVulnerabilities/CVEs";
import CNVDs from "../pages/ScanInfoPages/ExposureManagement/ExternalDetectedVulnerabilities/CNVDs";
import SSLVulnerabilities from "../pages/ScanInfoPages/ExposureManagement/ExternalDetectedVulnerabilities/SSLVulnerabilities";
import ExposedPanel from "../pages/ScanInfoPages/ExposureManagement/ExternalDetectedVulnerabilities/ExposedPanel";
import DefaultLogin from "../pages/ScanInfoPages/ExposureManagement/ExternalDetectedVulnerabilities/DefaultLogin";
import MisConfiguration from "../pages/ScanInfoPages/ExposureManagement/ExternalDetectedVulnerabilities/Misconfiguration";
import OtherVulnerabilities from "../pages/ScanInfoPages/ExposureManagement/ExternalDetectedVulnerabilities/Othervulnerabilities";

// exposure management dark web pages
import LeakedCredentials from "../pages/ScanInfoPages/ExposureManagement/DarkWeb/LeakedCredentials";
import BotnetLeaks from "../pages/ScanInfoPages/ExposureManagement/DarkWeb/BotnetLeaks";
import RansomewareGroupIntel from "../pages/ScanInfoPages/ExposureManagement/DarkWeb/RansomewareGroup";

// exposure management brand insight pages
import SimilarDomain from "../pages/ScanInfoPages/ExposureManagement/BrandInsights/SimilarDomain";
import BacklinkAudit from "../pages/ScanInfoPages/ExposureManagement/BrandInsights/BacklinkAudit";

// third party risk brand insight pages
import DomainSimilarities from "../pages/ScanInfoPages/ThirdPartyRisk/BrandInsights/DomainSimilarities";
import SecurityOverviewSubDomains from "../pages/ScanInfoPages/ThirdPartyRisk/SecurityOverview/SubDomains";
import SecurityOverviewIpAddress from "../pages/ScanInfoPages/ThirdPartyRisk/SecurityOverview/IpAddress";
import CriticalVulnerabilities from "../pages/ScanInfoPages/ThirdPartyRisk/RiskAssessment/CriticalVulnerabilities";
import SubdomainTakeover from "../pages/ScanInfoPages/ThirdPartyRisk/RiskAssessment/SubdomainTakeover";
import SSLAndTLSSecurity from "../pages/ScanInfoPages/ThirdPartyRisk/RiskAssessment/SSLAndTLSSecurity";
import ThirdPartyGitLeaks from "../pages/ScanInfoPages/ThirdPartyRisk/RiskAssessment/GitLeaks";
import BotnetInfiltrations from "../pages/ScanInfoPages/ThirdPartyRisk/CompromiseIndicators/BotnetInfiltration";
import CredentialsLeak from "../pages/ScanInfoPages/ThirdPartyRisk/CompromiseIndicators/CredentialsLeak";
import ThirdPartyRansomewareGroupLeaks from "../pages/ScanInfoPages/ThirdPartyRisk/CompromiseIndicators/RansomewareGropLeak";
import CorporateEmail from "../pages/ScanInfoPages/ThirdPartyRisk/CorporateEmailRisk";
import VendorRiskProfile from "../pages/ScanInfoPages/ThirdPartyRisk/VendorRiskProfile";
import DashboardOverview from "../pages/ScanInfoPages/ThirdPartyRisk/DashboardOverview";

//portfolio risk dashboard page
import PortfolioRiskDashboard from "../pages/ScanInfoPages/PortfolioRisk/Dashboard";

//reports exposure Mangement page
import ExposureManagementReports from "../pages/ScanInfoPages/Reports/ExposureManagement";

//O-Auth page
import OAuthPage from "../pages/OAuth";

//componetes page
import ComponentsPage from "../pages/Components";

import { getloggedInUserType } from "../utils/util";

function ProtectedRoute({ children }) {
    const location = useLocation();
    // console.log("test", getloggedInUserType())
    if (!getloggedInUserType()) {
    // Preserve the full path + query + hash the user was trying to reach
    const next = encodeURIComponent(location.pathname + location.search + location.hash);
        return <Navigate to={`/auth/login?next=${next}`} replace />;
    }

    return children;
}

const RouteComponents = () => {
    return (
        <Routes>
            <Route path="" element={<Navigate replace to={getloggedInUserType() === "internal" ? "/customers" : "/organization"} />} />
            <Route path="/auth/login" element={<LoginPage />} />
            <Route path="/auth/sso/microsoft/callback"  element={<LoginPage /> } />,
            <Route path="/auth/register" element={<RegistrationPage />} />
            <Route path="/auth/resend" element={<Resend />} />
            <Route path="/accountValidated" element={<AccountValidated />} />
            <Route path="/auth/confirmation" element={<ConfirmationForm />} />
            
            <Route path="/auth/forget-password" element={<ForgetPassword />} />
            <Route path="/auth/reset-password" element={<ResetPassword />}/>
            <Route path="/auth/verify-account" element={<VerifyAccount />}/>
            <Route path="/auth/reset-2fa" element={<ForgetPassword />}/>
            <Route path="/auth/reset-2fa-confirmation" element={<ForgetPassword />}/>

            <Route path="/organization" element={<ProtectedRoute><Organization /></ProtectedRoute>}/>
            <Route path="/organization/details/:organizationId" element={<ProtectedRoute><OrganizationDetails /></ProtectedRoute>}/>

            {/* from customer to organization details Page */}
            <Route path="/:customerId/organization/details/:organizationId" element={<ProtectedRoute><OrganizationDetails /></ProtectedRoute>}/>
            <Route path="/monitor" element={<ProtectedRoute><Monitor /></ProtectedRoute>}/>
            <Route path="/monitor/details/:monitorId" element={<ProtectedRoute><MonitorDetails /></ProtectedRoute>}/>
            <Route path="/users" element={<ProtectedRoute><Users /></ProtectedRoute>}/>
            <Route path="/users/details/:userId" element={<ProtectedRoute><UserDetails /></ProtectedRoute>}/>
            <Route path="/domain" element={<ProtectedRoute><Domain /></ProtectedRoute>}/>
            <Route path="/domain/details/:domainName" element={<ProtectedRoute><DomainDetails /></ProtectedRoute>}/>
            <Route path="/scan-history" element={<ProtectedRoute><ScanHistory /></ProtectedRoute>}/>
            <Route path="/scan-queue" element={<ProtectedRoute><ScanQueue /></ProtectedRoute>}/>
            <Route path="/account/settings" element={<ProtectedRoute><AccountSettings /></ProtectedRoute>}/>
            <Route path="/customers" element={<ProtectedRoute><Customers /></ProtectedRoute>}/>
            <Route path="/customers/details/:customerId" element={<ProtectedRoute><CustomerDetails /></ProtectedRoute>} />

            {/* scan info Pages */}

            {/* exposure management dashboard */}
            <Route path="/scan-info/exposure/dashboard" element={<ProtectedRoute><ScanInfo><ExposureDashboard /></ScanInfo></ProtectedRoute>}/>

            {/* exposure managemnt assest discovery pages */}
            <Route path="/scan-info/exposure/asset-discovery/domain-info/" element={<ProtectedRoute><ScanInfo><DomainInfo /></ScanInfo></ProtectedRoute>} />
            <Route path="/scan-info/exposure/asset-discovery/sub-domain" element={<ProtectedRoute><ScanInfo><SubDomains /></ScanInfo></ProtectedRoute>} />
            <Route path="/scan-info/exposure/asset-discovery/associated-domain" element={<ProtectedRoute><ScanInfo><AssociatedDomains /></ScanInfo></ProtectedRoute>} />
            <Route path="/scan-info/exposure/asset-discovery/ip-address" element={<ProtectedRoute><ScanInfo><IpAddress /></ScanInfo></ProtectedRoute>} />
            <Route path="/scan-info/exposure/asset-discovery/dns-records" element={<ProtectedRoute><ScanInfo><DNSRecords /></ScanInfo></ProtectedRoute>} />
            <Route path="/scan-info/exposure/asset-discovery/technologies" element={<ProtectedRoute><ScanInfo><Technologies /></ScanInfo></ProtectedRoute>} />
            <Route path="/scan-info/exposure/asset-discovery/ssl-records" element={<ProtectedRoute><ScanInfo><SSLRecords /></ScanInfo></ProtectedRoute>} />
            <Route path="/scan-info/exposure/asset-discovery/mobile-apps" element={<ProtectedRoute><ScanInfo><MobileApps /></ScanInfo></ProtectedRoute>} />

            {/* exposure management corporate email risk page */}
            <Route path="/scan-info/exposure/corporate-email-risk" element={<ProtectedRoute><ScanInfo><CorporateEmailRisk /></ScanInfo></ProtectedRoute>} />
            
            {/* exposure management concerning exposure pages */}
            <Route path="/scan-info/exposure/concerning-exposure/git-leaks" element={<ProtectedRoute><ScanInfo><GitLeaks /></ScanInfo></ProtectedRoute>} />
            <Route path="/scan-info/exposure/concerning-exposure/js-secrets" element={<ProtectedRoute><ScanInfo><JsSecrets /></ScanInfo></ProtectedRoute>} />
            <Route path="/scan-info/exposure/concerning-exposure/sensitive-exposure" element={<ProtectedRoute><ScanInfo><SensitiveExposure /></ScanInfo></ProtectedRoute>} />

            {/* exposure management external detected vulnerabilities pages */}
            <Route path="/scan-info/exposure/external-detected-vulnerabilities/sub-domain-takeover" element={<ProtectedRoute><ScanInfo><SubDomainTakeOver /></ScanInfo></ProtectedRoute>} />
            <Route path="/scan-info/exposure/external-detected-vulnerabilities/cves" element={<ProtectedRoute><ScanInfo><CVEs /></ScanInfo></ProtectedRoute>} />
            <Route path="/scan-info/exposure/external-detected-vulnerabilities/cnvds" element={<ProtectedRoute><ScanInfo><CNVDs /></ScanInfo></ProtectedRoute>} />
            <Route path="/scan-info/exposure/external-detected-vulnerabilities/ssl-vulnerabilities" element={<ProtectedRoute><ScanInfo><SSLVulnerabilities /></ScanInfo></ProtectedRoute>} />
            <Route path="/scan-info/exposure/external-detected-vulnerabilities/exposed-panel" element={<ProtectedRoute><ScanInfo><ExposedPanel /></ScanInfo></ProtectedRoute>} />
            <Route path="/scan-info/exposure/external-detected-vulnerabilities/default-login" element={<ProtectedRoute><ScanInfo><DefaultLogin /></ScanInfo></ProtectedRoute>} />
            <Route path="/scan-info/exposure/external-detected-vulnerabilities/misconfiguration" element={<ProtectedRoute><ScanInfo><MisConfiguration /></ScanInfo></ProtectedRoute>} />
            <Route path="/scan-info/exposure/external-detected-vulnerabilities/other-vulnerabilities" element={<ProtectedRoute><ScanInfo><OtherVulnerabilities /></ScanInfo></ProtectedRoute>} />

            {/* exposure management dark web pages */}
            <Route path="/scan-info/exposure/dark-web/leaked-credentials" element={<ProtectedRoute><ScanInfo><LeakedCredentials /></ScanInfo></ProtectedRoute>} />
            <Route path="/scan-info/exposure/dark-web/botnet-leaks" element={<ProtectedRoute><ScanInfo><BotnetLeaks /></ScanInfo></ProtectedRoute>} />
            <Route path="/scan-info/exposure/dark-web/ransomeware-group-intel" element={<ProtectedRoute><ScanInfo><RansomewareGroupIntel /></ScanInfo></ProtectedRoute>} />

            {/* exposure management brand insight pages */}
            <Route path="/scan-info/exposure/brand-insight/similar-domain" element={<ProtectedRoute><ScanInfo><SimilarDomain /></ScanInfo></ProtectedRoute>} />
            <Route path="/scan-info/exposure/brand-insight/backlink-audit" element={<ProtectedRoute><ScanInfo><BacklinkAudit /></ScanInfo></ProtectedRoute>} />

            {/* third party risk brand insight pages */}
            <Route path="/scan-info/third-party/brand-insight/domain-similarities" element={<ProtectedRoute><ScanInfo><DomainSimilarities /></ScanInfo></ProtectedRoute>} />
            <Route path="/scan-info/third-party/security-overview/subdomains" element={<ProtectedRoute><ScanInfo><SecurityOverviewSubDomains /></ScanInfo></ProtectedRoute>} />
            <Route path="/scan-info/third-party/security-overview/ip-address" element={<ProtectedRoute><ScanInfo><SecurityOverviewIpAddress /></ScanInfo></ProtectedRoute>} />
            <Route path="/scan-info/third-party/risk-assessment/critical-vulnerabilities" element={<ProtectedRoute><ScanInfo><CriticalVulnerabilities /></ScanInfo></ProtectedRoute>} />
            <Route path="/scan-info/third-party/risk-assessment/subdomain-takeover" element={<ProtectedRoute><ScanInfo><SubdomainTakeover /></ScanInfo></ProtectedRoute>} />
            <Route path="/scan-info/third-party/risk-assessment/sslandtls-security" element={<ProtectedRoute><ScanInfo><SSLAndTLSSecurity /></ScanInfo></ProtectedRoute>} />
            <Route path="/scan-info/third-party/risk-assessment/git-leaks" element={<ProtectedRoute><ScanInfo><ThirdPartyGitLeaks /></ScanInfo></ProtectedRoute>}/>
            <Route path="/scan-info/third-party/compromise-indicators/botnet-infiltrations" element={<ProtectedRoute><ScanInfo><BotnetInfiltrations /></ScanInfo></ProtectedRoute>}/>
            <Route path="/scan-info/third-party/compromise-indicators/credentials-leaks" element={<ProtectedRoute><ScanInfo><CredentialsLeak /></ScanInfo></ProtectedRoute>}/>
            <Route path="/scan-info/third-party/compromise-indicators/ransomeware-group-leaks" element={<ProtectedRoute><ScanInfo><ThirdPartyRansomewareGroupLeaks /></ScanInfo></ProtectedRoute>}/>
            <Route path="/scan-info/third-party/vendor-risk-profile" element={<ProtectedRoute><ScanInfo><VendorRiskProfile /></ScanInfo></ProtectedRoute>}/>

             {/* third party risk brand insight pages */}
             <Route path="/scan-info/third-party/corporate-email-risk" element={<ProtectedRoute><ScanInfo><CorporateEmail /></ScanInfo></ProtectedRoute>} />
              
              {/* third party risk Dsahboard Overview pages */}
             <Route path="/scan-info/third-party/dashboard-overview" element={<ProtectedRoute><ScanInfo><DashboardOverview /></ScanInfo></ProtectedRoute>} />

            {/* portfolio risk dashboard */}
            <Route path="/scan-info/portfolio/dashboard" element={<ProtectedRoute><ScanInfo><PortfolioRiskDashboard /></ScanInfo></ProtectedRoute>} />

            {/* Scan Info reports dark web pages */}
            <Route path="/scan-info/reports/exposure-management" element={<ProtectedRoute><ScanInfo><ExposureManagementReports /></ScanInfo></ProtectedRoute>} />

            <Route path="/oauth/authorize" element={<ProtectedRoute><OAuthPage /></ProtectedRoute>}/>
            
            <Route path="/components" element={<ComponentsPage />} />
        </Routes>
    )
}

export default RouteComponents;